<template>
  <div class="custom-tool" style="display: flex;padding:0 20px;">
<!--    overflow: scroll;-->
    <div style="display: flex;justify-content: space-between;width:100%;overflow-x: visible;overflow-y: visible;">

      <!-- 容器顶部左侧时间段 -->
      <div v-show="showTimeArea" style="display: flex;align-items: center;margin-right:20px;">
        <div style="font-size: 14px;color: #606266;line-height: 14px;font-weight: 400;margin-right: 8px;white-space:nowrap;">
          {{ timeAreaText }}：</div>
          <CustomDateAreaPicker :default-start="defaultDateArea.defaultStart" :default-end="defaultDateArea.defaultEnd" @dateAreaChange="dateAreaChange"/>
      </div>
      <!-- 容器顶部截至时间选择器 -->
      <div v-show="showTime" style="display: flex;align-items: center;margin-right:20px;">
        <div style="font-size: 14px;color: #606266;line-height: 14px;font-weight: 400;margin-right: 8px;">截止至</div>
        <el-date-picker
            v-model="selectDate"
            @change="dateChange"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择截止日期"
            >
        </el-date-picker>
      </div>
      <!-- 容器顶部截至时间点 -->
      <div v-show="showTimeText" style="display: flex;align-items: center;margin-right:20px;">
        <div style="font-size: 14px;color: #606266;line-height: 14px;font-weight: 400;margin-right: 8px;">截止至{{ selectDate }}</div>
      </div>

      <div v-show="!showTimeArea&&!showTime&&!showTimeText" class="leftPlaceholder"></div>

      <!-- 容器顶部右侧筛选按钮组 -->
      <div v-if="!showTodoListBtns" style="display:flex;">
        <!-- 业绩表现 快捷下拉筛选项 -->
        <!-- align-items:center 让下拉框保持自身 40px 高，与左侧日期框对齐（否则会被拉伸成整条 60px） -->
        <div v-if="showPerformanceSelect" style="display: flex; align-items: center; gap: 12px; padding: 0 20px">
          <el-select 
            v-for="(item, key) in filterOptions"
            v-model="filterOptions[key].value" 
            :placeholder="item.name"
            @change="seeFilterData(key, item)"
            clearable
            style="width: 120px;">
            <el-option
              v-for="item in filterOptions[key].options"
              :key="item.key"
              :value="item.key">
            </el-option>
          </el-select>
        </div>
        <!-- 查看明细按钮 -->
        <div v-if="showCustomBtn" class="imgbox" style="padding-left: 0px;">
          <el-button class="viewBtn is-solid" @click="$emit('customBtnClick')">{{customBtnText}}</el-button>
        </div>
        <!-- 看我小组按钮 -->
        <div v-if="showSeeMyTeam" class="imgbox" style="padding-left: 0px;">
          <el-button class="viewBtn" :class="{'is-active': todoListSelectBtn=='seeMyTeam'}" @click="seeMyTeamNormal">看我小组</el-button>
        </div>
        <!-- 看我部门按钮 -->
        <div v-if="showSeeMyDept" class="imgbox" style="padding-left: 0px;">
          <el-button class="viewBtn" :class="{'is-active': todoListSelectBtn=='seeMyDept'}" @click="seeMyDeptNormal">看我部门</el-button>
        </div>
        <!-- 筛选条件按钮 -->
        <div v-if="showFilter" class="imgbox">
          <CustomFilter ref="normalFilter" :column_mapper="column_mapper" @filterChange="filterChange"/>
        </div>
        <!-- 导出按钮 -->
        <div v-if="showExport" class="imgbox">
          <div class="export" @click="exportExcel"></div>
        </div>
        <!-- 刷新按钮 -->
        <div v-if="showRefresh" class="imgbox">
          <div class="refresh" @click="refresh"></div>
        </div>
      </div>
      <div v-else style="display: flex;overflow: scroll;">
        <!-- 看我自己按钮 -->
        <div class="imgbox" style="padding-left: 0px;">
          <el-button class="viewBtn" :class="{'is-active': todoListSelectBtn=='seeMyself'}" @click="seeMyself">看我自己</el-button>
        </div>
        <!-- 看我小组按钮 -->
        <div class="imgbox" style="padding-left: 0px;">
          <el-button class="viewBtn" :class="{'is-active': todoListSelectBtn=='seeMyTeam'}" @click="seeMyTeam">看我小组</el-button>
        </div>
        <!-- 看我部门按钮 -->
        <div class="imgbox" style="padding-left: 0px;">
          <el-button class="viewBtn" :class="{'is-active': todoListSelectBtn=='seeMyDept'}" @click="seeMyDept">看我部门</el-button>
        </div>
        <div class="imgbox" style="padding-left: 0px;">
          <CustomFilter ref="todoListFilter" type="text" :column_mapper="column_mapper" @filterChange="filterChange"/>
        </div>
        <div class="imgbox" style="padding-left: 0px;padding-right: 40px;">
          <el-button type="primary" @click="exportExcel">导出</el-button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import selectoption from "@/component/assets/selectoption.json";
import {
  getLastMonthEndDate,
  getLastMonthStartDate, getLastQuarterEndDate,
  getLastQuarterStartDate, getLastWeekEndDate,
  getLastWeekStartDate, getLastYearEndDate,
  getLastYearStartDate, getMonthEndDate, getMonthStartDate, getQuarterEndDate, getQuarterStartDate, getWeekEndDate,
  getWeekStartDate, getYearEndDate, getYearStartDate
} from "@/utils/util";
import CustomDateAreaPicker from "@/component/Performance/topTool/CustomDateAreaPicker";
import CustomFilter from "@/component/Performance/topTool/CustomFilter";

export default {
  name: "CustomTool",
  components:{
    CustomDateAreaPicker,
    CustomFilter
  },
  props:{
    showTodoListBtns:{
      type:Boolean,
      default:false
    },
    showTimeText:{
      type:Boolean,
      default:false
    },
    showTime:{
      type:Boolean,
      default:true
    },
    showTimeArea:{
      type:Boolean,
      default:false
    },
    timeAreaText:{
      type:String,
      default:"截至日期"
    },
    showCustomBtn:{
      type:Boolean,
      default:false
    },
    customBtnText:{
      type:String,
      default:"查看明细"
    },
    showSeeMyDept:{
      type:Boolean,
      default:false
    },
    showSeeMyTeam:{
      type:Boolean,
      default:false
    },
    showFilter:{
      type:Boolean,
      default:true
    },
    showExport:{
      type:Boolean,
      default:true
    },
    showRefresh:{
      type:Boolean,
      default:true
    },
    filterArchiveData:{
      type:Object
    },
    column_mapper:{
      type:Object
    },
    defaultDateArea:{
      type:Object,
      default:()=>{
        return {
          defaultStart:getMonthStartDate().format('yyyy-MM-dd'),
          defaultEnd:new Date().format('yyyy-MM-dd')
        }
      }
    },
    defaultTime:{
      type:String,
      default:new Date().format('yyyy-MM-dd')
    },
    todoListInfo:{
      type:Object
    },
    queryCondRefresh: {
      type:Number,
      default:0
    },

    showPerformanceSelect: {
      type: Boolean,
      default: false
    },
    filterOptions: {
      type: Object,
      default: () => {}
    }
  },
  data(){
    return {
      //默认时间区间
      // defaultDateArea:{
      //   defaultStart:getMonthStartDate().format('yyyy-MM-dd'),
      //   defaultEnd:new Date().format('yyyy-MM-dd'),
      // },

      //选择时间段
      selectDateArea:{
        start:this.defaultDateArea.defaultStart,
        end:this.defaultDateArea.defaultEnd,
      },

      selectDate:"",

      //筛选结果的列表
      queryCond: [],
      todoListSelectBtn:""
    }
  },

  watch: {
    queryCondRefresh(newVal){
      console.log(newVal)
      if(newVal){
        console.log('***')
        this.$refs.normalFilter.emptySelect();
      }
    }
  },

  mounted() {
    this.selectoption = selectoption.selectoption
    this.selectDate = this.defaultTime
    window.vm3 = this
  },

  methods:{
    seeFilterData(key, item) {
      // 清空其余选项（一次只能筛一种条件）
      this.$emit('setFilterData', { key, value: item.value })

      if (item.value) {
        this.$refs.normalFilter.submitSelectByQueryCond({
          type: 'see' + key,
          columnName: key,
          columnValue: item.value,
          filter: 'eq'
        })
      } else {
        this.$refs.normalFilter.removeSelect({
          type: 'see' + key,
          columnName: key,
          columnValue: item.value,
          filter: 'eq'
        })
      }
      this.$forceUpdate()
    },

    seeMyself(){
      // console.log('seeMyself')

      this.todoListSelectBtn = "seeMyself"

      if(this.column_mapper.hasOwnProperty(this.todoListInfo.currentSelectLeftItemKey)&&!this.queryCond.find(q=>q.type=="seeMyself")){
        this.$refs.todoListFilter.submitSelectByQueryCond({
          type:"seeMyself",
          columnName:this.todoListInfo.currentSelectLeftItemKey,
          columnValue:this.$cookies.get("username"),
          filter: "eq"
        })
      }

    },
    seeMyTeam(){
      // console.log('seeMyTeam')
      this.todoListSelectBtn = "seeMyTeam"

      let userDeptInfo =  this.todoListInfo.userDeptInfo
      let p_dept_name = userDeptInfo.p_dept_name ? userDeptInfo.p_dept_name: ""//部门
      let s_dept_name = userDeptInfo.s_dept_name ? userDeptInfo.s_dept_name : ""//小组


      if(!this.queryCond.find(q=>q.type=="seeMyTeam")){
        if(p_dept_name=="营销部门"){
          this.$refs.todoListFilter.submitSelectByQueryCond({
            type:"seeMyTeam",
            columnName:"dept:sales_s_dept",
            columnValue:s_dept_name,
            filter: "eq"
          })
        }else{
          this.$refs.todoListFilter.submitSelectByQueryCond({
            type:"seeMyTeam",
            columnName:"dept:responsible_s_dept",
            columnValue:s_dept_name,
            filter: "eq"
          })
        }



      }
    },

    seeMyTeamNormal(){
      // console.log('seeMyTeamNormal')
      this.todoListSelectBtn = "seeMyTeam"

      let userDeptInfo =  this.todoListInfo.userDeptInfo
      let p_dept_name = userDeptInfo.p_dept_name ? userDeptInfo.p_dept_name: ""//部门
      let s_dept_name = userDeptInfo.s_dept_name ? userDeptInfo.s_dept_name : ""//小组


      if(!this.queryCond.find(q=>q.type=="seeMyTeam")){
        if(p_dept_name=="营销部门"){
          this.$refs.normalFilter.submitSelectByQueryCond({
            type:"seeMyTeam",
            columnName:"sales_s_dept",
            columnValue:s_dept_name,
            filter: "eq"
          })
        }else{
          this.$refs.normalFilter.submitSelectByQueryCond({
            type:"seeMyTeam",
            columnName:"responsible_s_dept",
            columnValue:s_dept_name,
            filter: "eq"
          })
        }
      }
    },


    seeMyDeptNormal(){
      // console.log('seeMyDeptNormal')
      this.todoListSelectBtn = "seeMyDept"

      let userDeptInfo =  this.todoListInfo.userDeptInfo
      let p_dept_name = userDeptInfo.p_dept_name ? userDeptInfo.p_dept_name: ""//部门
      let s_dept_name = userDeptInfo.s_dept_name ? userDeptInfo.s_dept_name : ""//小组


      if(!this.queryCond.find(q=>q.type=="seeMyDept")){
        if(p_dept_name=="营销部门"){
          this.$refs.normalFilter.submitSelectByQueryCond({
            type:"seeMyDept",
            columnName:"sales_s_dept",
            columnValue:s_dept_name,
            filter: "eq"
          })
        }else{
          this.$refs.normalFilter.submitSelectByQueryCond({
            type:"seeMyDept",
            columnName:"responsible_p_dept",
            columnValue:p_dept_name,
            filter: "eq"
          })
        }
      }
    },

    seeMyDept(){
      // console.log('seeMyDept')
      this.todoListSelectBtn = "seeMyDept"

      let userDeptInfo =  this.todoListInfo.userDeptInfo
      let p_dept_name = userDeptInfo.p_dept_name ? userDeptInfo.p_dept_name: ""//部门
      let s_dept_name = userDeptInfo.s_dept_name ? userDeptInfo.s_dept_name : ""//小组


      if(!this.queryCond.find(q=>q.type=="seeMyDept")){
        if(p_dept_name=="营销部门"){
          this.$refs.todoListFilter.submitSelectByQueryCond({
            type:"seeMyDept",
            columnName:"dept:sales_s_dept",
            columnValue:s_dept_name,
            filter: "eq"
          })
        }else{
          this.$refs.todoListFilter.submitSelectByQueryCond({
            type:"seeMyDept",
            columnName:"dept:responsible_p_dept",
            columnValue:p_dept_name,
            filter: "eq"
          })
        }
      }
    },
    removeSelect(item){
      if(this.showTodoListBtns){
        this.$refs.todoListFilter.removeSelect(item)
      }
      if(this.showSeeMyDept){
        this.$refs.normalFilter.removeSelect(item)
      }
      this.seeFilterData(null, {})
    },
    /**
     * 选择日期区间变化
     * @param dates
     */
    dateAreaChange(dates){
      // console.log('dateAreaChange/dates',dates)
      this.selectDateArea.start = dates[0].date
      this.selectDateArea.end = dates[1].date
      this.findSelsectChanged('dateAreaChange')
    },

    dateChange(){
      // console.log('dateChange',this.selectDate)
      this.findSelsectChanged('dateAreaChange','time')

    },


    /**
     * 筛选条件变化
     * @param queryCond
     */
    filterChange(queryCond){
      // console.log('filterChange/queryCond',queryCond)
      if(!queryCond.find(s=>s.type==this.todoListSelectBtn)){
        // console.log('找不到')
        this.todoListSelectBtn = ""
      }
      this.queryCond = JSON.parse(JSON.stringify(queryCond))
      this.findSelsectChanged('filterChange')
    },


    /**
     * 表格导出excel
     */
    exportExcel() {
      // console.log('exportExcel')
      this.$emit('export')
    },


    /**
     * 页面刷新
     */
    async refresh() {
      // console.log('刷新')
      this.findSelsectChanged('refresh')
    },


    /**
     * 判断条件差异（有差异则显示已更改图标）
     */
    findSelsectChanged(fromFunction,timeType='area') {
      // console.log('筛选条件更新后，更新侧边栏内部数据-findSelsectChanged,formFunction', fromFunction)
      let content = {
        queryCond: this.queryCond
        // time:this.selectDate
        // accu_start_end_date
      }
      if(this.showTimeArea){
        content['timerange'] = {
          start:this.selectDateArea.start,
          end:this.selectDateArea.end
        }
      }
      if(this.showTime){
        content['time'] = this.selectDate
      }
      // if(timeType=='area'){
      //  content = {
      //    queryCond: this.queryCond
      //    // time:this.selectDate
      //    // accu_start_end_date
      //  }
      //  if(this.showTimeArea){
      //    content['timerange'] = {
      //      start:this.selectDateArea.start,
      //      end:this.selectDateArea.end
      //    }
      //  }
      //  if(this.showTime){
      //    time:this.selectDate
      //  }
      // }else{
      //   content = {
      //     queryCond: this.queryCond,
      //     time:this.selectDate
      //   }
      // }

      // console.log('findSelsectChanged/content',content)
      this.$emit('filters',JSON.parse(JSON.stringify(content)))

    },
  }
}
</script>

<style scoped lang="scss">
/* 工具条上的文字按钮（看我自己/看我小组/看我部门/查看明细）。
   原来用 inline style 给 el-button 刷 #409EFF 实心，出现两个问题：
     1. el-button 默认描边 #DCDFE6 还在，蓝底外圈套一圈灰边；
     2. 选中态 #9FCEFF + 白字，对比度只有 2.0:1，基本看不清。
   现在统一成「未选中白底蓝字描边 / 选中实心」：
     实心用主题蓝 #2783EF 下沉 12% 的 #2273D2，白字对比度 4.8:1。 */
.viewBtn {
  padding: 12px 16px; /* 20px -> 16px，略微收窄，缓解工具条横向拥挤 */
  color: #2273D2;
  background: #FFFFFF;
  border-color: #A9CDF7;

  &:hover,
  &:focus {
    color: #1E68C0;
    background: #F2F8FF;
    border-color: #7FB8F2;
  }

  /* 已选视图范围，或本身就是主操作按钮 */
  &.is-active,
  &.is-solid {
    color: #FFFFFF;
    background: #2273D2;
    border-color: #2273D2;

    &:hover,
    &:focus {
      color: #FFFFFF;
      background: #1E68C0;
      border-color: #1E68C0;
    }
  }
}

.imgbox {
  position: relative;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  text-align: center;
  padding:0 15px;

  /* 工具栏图标：源图是 30×31 位图，统一按 22px 显示。
   * 显式 background-size 既收小了图标，也去掉了原来溢出的 1px 平铺。
   * 尺寸只在这里定义，下面各图标只负责自己的 background-image。 */
  .refresh,
  .coloums,
  .coloumSelect,
  .select,
  .export,
  .fullScreen {
    width: 22px;
    height: 22px;
    background-size: contain;
    background-repeat: no-repeat;
    background-position: center;
  }

  &:hover {
    cursor: pointer;
  }

  .refresh {
    background-image: url("../../../assets/img/refresh.png");
    position: relative;

    &:hover::before {
      content: '刷新';
      display: block;
      position: absolute;
      top: calc(100% + 12px);
      left: 50%;
      transform: translateX(-50%);
      background: #9FA8B3;
      color: rgb(255, 255, 255);
      font-size: 12px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      width: 40px;
      padding: 5px;
      border-radius: 3px;
      z-index: 999;
    }

    &:hover {
      background-image: url("../../../assets/img/refresh_active.png");
    }
  }

  .coloums {
    background-image: url("../../../assets/img/coloums.png");
    position: relative;

    &:hover::before {
      content: '页面行数';
      display: block;
      position: absolute;
      top: calc(100% + 12px);
      left: 50%;
      transform: translateX(-50%);
      background: #9FA8B3;
      color: rgb(255, 255, 255);
      font-size: 12px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      width: 50px;
      padding: 5px;
      border-radius: 3px;
      z-index: 999;
    }

    &:hover {
      background-image: url("../../../assets/img/coloums_active.png");
    }
  }

  .coloumSelect {
    background-image: url("../../../assets/img/coloumSelect.png");
    position: relative;

    &:hover::before {
      content: '筛选列';
      display: block;
      position: absolute;
      top: calc(100% + 12px);
      left: 50%;
      transform: translateX(-50%);
      background: #9FA8B3;
      color: rgb(255, 255, 255);
      font-size: 12px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      width: 50px;
      padding: 5px;
      border-radius: 3px;
      z-index: 999;
    }

    &:hover {
      background-image: url("../../../assets/img/coloumSelect_active.png");
    }
  }

  .select {
    background-image: url("../../../assets/img/select.png");
    position: relative;

    &:hover::before {
      content: '筛选条件';
      display: block;
      position: absolute;
      top: calc(100% + 12px);
      left: 50%;
      transform: translateX(-50%);
      background: #9FA8B3;
      color: rgb(255, 255, 255);
      font-size: 12px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      width: 50px;
      padding: 5px;
      border-radius: 3px;
      z-index: 999;
    }

    &:hover {
      background-image: url("../../../assets/img/select_active.png");
    }
  }

  .export {
    background-image: url("../../../assets/img/export.png");
    position: relative;

    &:hover::before {
      content: '导出';
      display: block;
      position: absolute;
      top: calc(100% + 12px);
      left: 50%;
      transform: translateX(-50%);
      background: #9FA8B3;
      color: rgb(255, 255, 255);
      font-size: 12px;
      font-family: SourceHanSansSC-Regular, SourceHanSansSC;
      font-weight: 400;
      width: 40px;
      padding: 5px;
      border-radius: 3px;
      z-index: 999;
    }

    &:hover {
      background-image: url("../../../assets/img/export_active.png");
    }
  }

  .fullScreen {
    background-image: url("../../../assets/img/fullScreen.png");
    // &:hover{
    //   background-image: url("../assets/img/fullScreen_active.png");
    // }
  }
}
</style>
